import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {SegmentValueObject} from '../ValueObjects/SegmentValueObject.js'
import {VehicleConfiguratorTrackingDataValueObject} from '../ValueObjects/VehicleConfiguratorTrackingDataValueObject.js'

class GetVehicleConfiguratorEventTrackingDataUseCase extends UseCase {
  static create() {
    return new GetVehicleConfiguratorEventTrackingDataUseCase()
  }

  @tracer({metric: 'GetVehicleConfiguratorEventTrackingDataUseCase#execute'})
  @AsyncInlineError()
  async execute({action, step, make, makeId, model, modelId, fuelType, trimLevel, engine, color, zipcode}) {
    try {
      const vehicleConfiguratorTrackingDataValueObject = VehicleConfiguratorTrackingDataValueObject.create({
        action,
        step,
        make,
        makeId,
        model,
        modelId,
        fuelType,
        trimLevel,
        engine,
        color,
        zipcode
      })

      return SegmentValueObject.create({
        eventName: vehicleConfiguratorTrackingDataValueObject.event,
        hitOrigin: vehicleConfiguratorTrackingDataValueObject.hitOrigin,
        hitInformation: vehicleConfiguratorTrackingDataValueObject.hitInformation,
        hitInformation2: vehicleConfiguratorTrackingDataValueObject.hitInformation2,
        brandId: vehicleConfiguratorTrackingDataValueObject.brandId,
        modelId: vehicleConfiguratorTrackingDataValueObject.modelId
      })
    } catch (error) {
      return Promise.reject(DomainSharedError.createGenericError({cause: error}))
    }
  }
}

export const factory = GetVehicleConfiguratorEventTrackingDataUseCase.create
